// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisabledMessagedPanel__container-b0db68 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 72px;
}

.DisabledMessagedPanel__description-e24f38 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/DisabledMessagedPanel/DisabledMessagedPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 72px;\n}\n\n.description {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DisabledMessagedPanel__container-b0db68`,
	"description": `DisabledMessagedPanel__description-e24f38`
};
module.exports = ___CSS_LOADER_EXPORT___;
